import { render, staticRenderFns } from "./SidebarUserSection.vue?vue&type=template&id=79cbb0f4&scoped=true"
import script from "./SidebarUserSection.vue?vue&type=script&lang=js"
export * from "./SidebarUserSection.vue?vue&type=script&lang=js"
import style0 from "./SidebarUserSection.vue?vue&type=style&index=0&id=79cbb0f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cbb0f4",
  null
  
)

export default component.exports